export const TAX_YEAR_HEADER = "tax-year";

let currentTaxYear: string | null = null;

export const setCurrentTaxYear = (taxYear: string | null): void => {
  currentTaxYear = taxYear;
};

export const getCurrentTaxYear = (): string | null => currentTaxYear;
